export default __webpack_public_path__ + "static/media/logo.230a496d.png";